// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "hr[data-v-581e156e]{border:none;border-style:solid;border-color:var(--neutral-lines-default);border-width:var(--line-width) 0 0 0;margin:0;padding:0}hr[thick][data-v-581e156e]:not([thick=false]){border-width:calc(var(--line-width-thick)/2) 0 calc(var(--line-width-thick)/2) 0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
